import type { Translations } from '@layers/app/stores/types/locale.ts'

import { replaceCustomerServicePhone } from '@layers/web/utils/customer-service.ts'
import { replaceDateFormatPlaceholder } from '@layers/web/utils/date.ts'
import type { SiteVariantTranslationReplacements } from '@layers/web/utils/types/site-variant.ts'

const applySiteVariantToTranslations = (
  translations: Translations,
  { customerServicePhone, dateFormatPlaceholder }: SiteVariantTranslationReplacements
): Translations => {
  const translationsWithPhone = customerServicePhone
    ? replaceCustomerServicePhone(translations, customerServicePhone)
    : translations

  return dateFormatPlaceholder
    ? replaceDateFormatPlaceholder(translationsWithPhone, dateFormatPlaceholder)
    : translationsWithPhone
}

export {
  applySiteVariantToTranslations,
}
